export default function IconBackArrow({ className }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            width="14"
            height="13"
            viewBox="0 0 14 13"
            fill="none"
        >
            <path
                d="M6.39062 0.353516L0.706192 6.03795L6.39062 11.7224"
                stroke="#373737"
            />
            <path d="M0.705078 6.04346L12.7055 6.04346V11.0963" stroke="#373737" />
        </svg>
    )
}
